import SermonsEmbed from './images/SermonsEmbed';
import AllThumbs from './Thumbs/AllThumbs';



const SermonLinksList = {
    tabHeading: 'TLN - Media Links',
    metaDescription: `A list of media links to noteworthy Sermons, Speeches, Teachings, Podcasts, Debates, etc. for further learning.`,
    keywords: ["TrueLibertyNorth", ],
    image: SermonsEmbed,
    pageHeading: 'Media Links',
    description: `The following is a list of Media Links to noteworthy Sermons, Speeches, Teachings, Interviews, Podcasts, Debates and such, as well 
    as links to institutions of Higher Learning. All links lead to legit Pages and contain enough information to conduct a private search, should any 
    of links ever become broken. The list is merely a starting point for those who wish to dig deeper into topics of interest.`,
    refresh: `Please REFRESH BROWSER for Updated List.`,
    linkList: [
        { firstName: `Fr. Chris`,
          lastName: `Alar, MIC`,
          thumb: AllThumbs.Alar,
          itemLinks: [
            { sermonTitle: `Does the Church Require Open Borders?`,
              sermonSubTitle: `What Does The Church Really Teach On Immigration?`,
              sermonDate: `February 13, 2025`,
              sermonChannel: `Divine Mercy`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=cPwZ7ixexYk`
            },
            { sermonTitle: `Charlie Kirk: Why?`,
              sermonSubTitle: `Fr. Chris Alar Makes an Interesting Connection`,
              sermonDate: `September 11, 2025`,
              sermonChannel: `Divine Mercy`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=RobA-j8yMJ0`
            },
            { sermonTitle: `The Political Party of Christ`,
              sermonSubTitle: `Fr. Chris Alar - Heaven's Politics`,
              sermonDate: `September 25, 2025`,
              sermonChannel: `Divine Mercy`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=Bk-ilAm3dp4`
            }
          ]
        },
        { firstName: `Aleph`,
          lastName: `Beta`,
          thumb: AllThumbs.Aleph,
          itemLinks: [
            { sermonTitle: `AlephBeta Home Page - Free Trials Available`,
              sermonSubTitle: `In-Depth Online Torah Learning for Adults`,
              sermonDate: ``,
              sermonChannel: `Alephbeta.org`,
              sermonDescript: ``,
              sermonLink: `https://www.alephbeta.org/`
            }
          ]
        },
        { firstName: `Bishop Robert`,
          lastName: `Barron`,
          thumb: AllThumbs.Barron,
          itemLinks: [
            { sermonTitle: `Is Jesus the King of Your Life?`,
              sermonSubTitle: `Bishop Barron’s Sunday Sermon`,
              sermonDate: `Nov 21, 2021`,
              sermonChannel: `Bishop Robert Barron`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=tICxaSQFJGo`
            },
            { sermonTitle: `Where to Go When You Cannot Go On`,
              sermonSubTitle: `Bishop Barron’s Sunday Sermon`,
              sermonDate: `Aug 8, 2021`,
              sermonChannel: `Bishop Robert Barron`,  
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=ZXzxu1mcFm8`
            },
            { sermonTitle: `Your Life is Not About You`,
              sermonSubTitle: `Bishop Barron’s Sunday Sermon`,
              sermonDate: `November 1, 2020`,
              sermonChannel: `Bishop Robert Barron`,  
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=IGkeOsCpN9g`
            },
            { sermonTitle: `Faith When You’re Frustrated with God`,
              sermonSubTitle: `Bishop Barron’s Sunday Sermon`,
              sermonDate: `June 27, 2021`,
              sermonChannel: `Bishop Robert Barron`,  
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=QDoMI9-_kb8`
            },
            { sermonTitle: `Beware of Blind Guides`,
              sermonSubTitle: `Bishop Barron’s Sunday Sermon`,
              sermonDate: `February 26, 2022`,
              sermonChannel: `Bishop Robert Barron`,  
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=svJKRuhAnGU`
            },
            { sermonTitle: `Trust in the Lord`,
              sermonSubTitle: `Bishop Barron’s Sunday Sermon`,
              sermonDate: `November 7, 2021`,
              sermonChannel: `Bishop Robert Barron`,  
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=M-hps7KCOXk`
            },
            { sermonTitle: `Don’t Play the Pride Game`,
              sermonSubTitle: `Bishop Barron’s Sunday Sermon`,
              sermonDate: `August 31, 2025`,
              sermonChannel: `Bishop Robert Barron`,  
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=ZAsqvLY15ds`
            },
            { sermonTitle: `Rabbi Soloveichik - The God of the Bible`,
              sermonSubTitle: `Bishop Barron Presents`,
              sermonDate: `August 28, 2025`,
              sermonChannel: `Bishop Robert Barron`,  
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=J398JpSMrtk`
            },
            { sermonTitle: `The Use — and Abuse — of Power`,
              sermonSubTitle: `Bishop Barron’s Sunday Sermon`,
              sermonDate: `September 20, 2025`,
              sermonChannel: `Bishop Robert Barron`,  
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=I4qsq_mNyfw`
            },
            { sermonTitle: `Trust in God’s Plan`,
              sermonSubTitle: `Bishop Barron’s Sunday Sermon`,
              sermonDate: `October 09, 2025`,
              sermonChannel: `Bishop Robert Barron`,  
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=8tdezuvXYA8`
            },
            { sermonTitle: `The Gospel Is Jesus Christ`,
              sermonSubTitle: `Bishop Barron’s Sunday Sermon`,
              sermonDate: `October 11, 2025`,
              sermonChannel: `Bishop Robert Barron`,  
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=IOfCRlJ1oos`
            }
          ]
        },
        { firstName: `David`,
          lastName: `Barton`,
          thumb: AllThumbs.Barton,
          itemLinks: [
            { sermonTitle: `The Controversy Over Thomas Jefferson's Bible`,
              sermonSubTitle: `Ben Shapiro - The Sunday Special`,
              sermonDate: `June 30, 2019`,
              sermonChannel: `DailyWire+`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=esvUZBMsnKo`
            }
          ]
        },
        { firstName: `Glenn`,
          lastName: `Beck`,
          thumb: AllThumbs.BeckG,
          itemLinks: [
            { sermonTitle: `From Lincoln to Charlie Kirk`,
              sermonSubTitle: `Glenn TV | Our New Calling | Ep 457`,
              sermonDate: `September 24, 2025`,
              sermonChannel: `Glenn Beck`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=5k-0Sncf_hw`
            },
            { sermonTitle: `A message to Christians after Michigan church shooting`,
              sermonSubTitle: `The Glenn Beck Program | Hour One 9/29/25`,
              sermonDate: `September 29, 2025`,
              sermonChannel: `Glenn Beck`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=gdVnq59D5_c`
            }
          ]
        },
        { firstName: `David`,
          lastName: `Berlinski`,
          thumb: AllThumbs.Berlinski,
          itemLinks: [
            { sermonTitle: `Uncommon Knowledge with David Berlinski`,
              sermonSubTitle: `“The Deniable Darwin”`,
              sermonDate: `July 8, 2019`,
              sermonChannel: `Hoover Institution`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=LuEaJDksxls`
            },
            { sermonTitle: `Mathematical Challenges to Darwin’s Theory of Evolution`,
              sermonSubTitle: `David Berlinski, David Gelernter, and Stephen Meyer`,
              sermonDate: `July 22, 2019`,
              sermonChannel: `Hoover Institution`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=noj4phMT9OE`
            },
            { sermonTitle: `David Berlinski`,
              sermonSubTitle: `The Ben Shapiro Show Sunday Special Ep. 78`,
              sermonDate: `Nov 24, 2019`,
              sermonChannel: `DailyWire+`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=tk6bJrvFTMM`
            }
          ]
        },
        { firstName: `John`,
          lastName: `Bevere`,
          thumb: AllThumbs.Bevere,
          itemLinks: [
            { sermonTitle: `7 Reasons Why You're Still A Baby Christian`,
              sermonSubTitle: `You Need To Try Harder`,
              sermonDate: `July 17, 2024`,
              sermonChannel: `John Bevere`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=5-Qyd_BnE4s`
            },
            { sermonTitle: `Jesus Threatened to Shut This Church Down – Here’s What Went Wrong`,
              sermonSubTitle: `He Warned Them`,
              sermonDate: `July 4, 2025`,
              sermonChannel: `John Bevere`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=3CjiFuDCE_s`
            },
            { sermonTitle: `Escaping the TRAP of "Casual Christianity"`,
              sermonSubTitle: ``,
              sermonDate: `June 26, 2024`,
              sermonChannel: `John Bevere`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=4zpLVFsmh5A`
            },
            { sermonTitle: `Satan Is Using Certain Preachers to Brainwash You`,
              sermonSubTitle: `Why Aren't Pastors Addressing This?`,
              sermonDate: `October 4, 2024`,
              sermonChannel: `John Bevere`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=8TetBxZ95DY`
            },
            { sermonTitle: `You've Been Lied to About Hell.`,
              sermonSubTitle: `The Truth About Hell`,
              sermonDate: `November 15, 2024`,
              sermonChannel: `John Bevere`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=61x00hiVHIc`
            },
            { sermonTitle: `The Scariest Question You Can Ask`,
              sermonSubTitle: `Once Saved Always Saved?`,
              sermonDate: `December 13, 2024`,
              sermonChannel: `John Bevere`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=VAXtROuMKIo`
            }
          ]
        },
        { firstName: `William F.`,
          lastName: `Buckley Jr.`,
          thumb: AllThumbs.Buckley,
          itemLinks: [
            { sermonTitle: `The Decline of Christianity`,
              sermonSubTitle: `Firing Line - Billy Graham`,
              sermonDate: `April 2016`,
              sermonChannel: `Hoover Institution Library & Archives`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=SoaUw3ZrcVQ`
            }
          ]
        },
        { firstName: `Milton`,
          lastName: `Friedman`,
          thumb: AllThumbs.Friedman,
          itemLinks: [
            { sermonTitle: `Milton Friedman - Socialism is Force`,
              sermonSubTitle: ``,
              sermonDate: ``,
              sermonChannel: `LibertyPen`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=DYeYPcougmA`
            }
          ]
        },
        { firstName: `Billy`,
          lastName: `Graham`,
          thumb: AllThumbs.Graham,
          itemLinks: [
            { sermonTitle: `The High Cost of Following Christ`,
              sermonSubTitle: `Billy Graham Classic Sermon`,
              sermonDate: `Orlando, FL, 1983`,
              sermonChannel: `Billy Graham Evangelistic Association`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=-vOGxGce3OM`
            },
            { sermonTitle: `Obstacles to Heaven`,
              sermonSubTitle: `Billy Graham Classic Sermon`,
              sermonDate: `Orlando, FL, 1983`,
              sermonChannel: `Billy Graham Evangelistic Association`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=sMvCT5uz_xU`
            },
            { sermonTitle: `Hanging Loose`,
              sermonSubTitle: `Billy Graham Classic Sermon`,
              sermonDate: `Tampa, FL, 1979`,
              sermonChannel: `Billy Graham Evangelistic Association`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=J_gcOK0uZ3o`
            },
            { sermonTitle: `The Real Meaning of the Cross`,
              sermonSubTitle: `Billy Graham Classic Sermon`,
              sermonDate: `Hartford, CT, 1985`,
              sermonChannel: `Billy Graham Evangelistic Association`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=z1mcW0RSW7w`
            },
            { sermonTitle: `Conscience`,
              sermonSubTitle: `Billy Graham Classic Sermon`,
              sermonDate: `Memphis, TN, 1978`,
              sermonChannel: `Billy Graham Evangelistic Association`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=1t2XZem1XuQ`
            },
            { sermonTitle: `Is There A Hell?`,
              sermonSubTitle: `Billy Graham Classic Sermon`,
              sermonDate: `Sacramento, CA, 1983`,
              sermonChannel: `Billy Graham Evangelistic Association`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=KNgoD5Ekpjg`
            },
            { sermonTitle: `Choices We Make`,
              sermonSubTitle: `Billy Graham Classic Sermon`,
              sermonDate: `Tallahassee, FL, 1986`,
              sermonChannel: `Billy Graham Evangelistic Association`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=UdsrlWUkTw0`
            }
          ]
        },
        { firstName: `Pastor Matt`,
          lastName: `Hagee`,
          thumb: AllThumbs.HageeM,
          itemLinks: [
            { sermonTitle: `"The Potter's Hands"`,
              sermonSubTitle: `Sunday Conversation Bible Study`,
              sermonDate: `September 24, 2025`,
              sermonChannel: `Hagee Ministries`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=Wnu13uPmN34`
            }
          ]
        },
        { firstName: `Hillsdale`,
          lastName: `College`,
          thumb: AllThumbs.Hillsdale,
          itemLinks: [
            { sermonTitle: `The Genesis Story | Lecture One`,
              sermonSubTitle: `Dr. Justin Jackson`,
              sermonDate: ``,
              sermonChannel: `Hillsdale College`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=OhbqinQsWTc`
            },
            { sermonTitle: `Intro to Aristotle's Ethics | Lecture 1: The Good`,
              sermonSubTitle: `Dr. Larry P. Arnn`,
              sermonDate: ``,
              sermonChannel: `Hillsdale College`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=9YaaBgDg57g`
            },
            { sermonTitle: `Hillsdale College FREE Online Courses`,
              sermonSubTitle: `Overview / Sign In / Sign Up Page`,
              sermonDate: ``,
              sermonChannel: `Hillsdale.edu`,
              sermonDescript: ``,
              sermonLink: `https://online.hillsdale.edu/`
            },
            { sermonTitle: `Christianity and the Power of Reason | Bishop Robert Barron`,
              sermonSubTitle: `The Larry Arnn Show - Faith vs. Tyranny`,
              sermonDate: `April 22, 2025`,
              sermonChannel: `Hillsdale College`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=vuiun-4W2Ns`
            }
          ]
        },
        { firstName: `Charlie`,
          lastName: `Kirk`,
          thumb: AllThumbs.KirkC,
          itemLinks: [
            { sermonTitle: `HOW BEING OBEDIENT TO GOD WILL CHANGE YOUR LIFE`,
              sermonSubTitle: `God is Testing Your Willingness`,
              sermonDate: `February 1, 2024`,
              sermonChannel: `TPUSA Faith`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=FYfdDOJ4PpQ`
            }
          ]
        },
        { firstName: `John`,
          lastName: `Lennox`,
          thumb: AllThumbs.Lennox,
          itemLinks: [
            { sermonTitle: `What Atheists Miss About Jesus - John Lennox`,
              sermonSubTitle: ``,
              sermonDate: `May 20, 2025`,
              sermonChannel: `Alex O'Connor`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=S87oH_6pJJ8`
            },
            { sermonTitle: `Why This Oxford Mathematician is Confident God Exists`,
              sermonSubTitle: `John Lennox`,
              sermonDate: `May 22, 2025`,
              sermonChannel: `Alex O'Connor`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=3gKCwldMZS8`
            },
            { sermonTitle: `John Lennox: The Question of Science and God - Part 1`,
              sermonSubTitle: ``,
              sermonDate: `January 12, 2018`,
              sermonChannel: `Socrates in the City`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=gDjNv-ea56E`
            },
            { sermonTitle: `John Lennox: The Question of Science and God - Part 2`,
              sermonSubTitle: ``,
              sermonDate: `January 23, 2018`,
              sermonChannel: `Socrates in the City`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=Tr3ghb6JG6A`
            },
            { sermonTitle: `Has the West Lost Its Moral Compass?`,
              sermonSubTitle: `John Lennox`,
              sermonDate: `May 14, 2025`,
              sermonChannel: `OCCA The Oxford Centre for Christian Apologetics`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=jyLVGwjJSKg`
            },
            { sermonTitle: `Why Science Buries Atheism, Not God`,
              sermonSubTitle: `Professor John Lennox`,
              sermonDate: `2019`,
              sermonChannel: `Socrates in the City`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=g5r4l55MUe0`
            },
            { sermonTitle: `Keeping the Faith through Every Season`,
              sermonSubTitle: `John Lennox - Finishing Life Well`,
              sermonDate: `October 6, 2025`,
              sermonChannel: `KeithandKristyn Getty`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=EW7-4OgmrI0`
            },
            { sermonTitle: `Why Christianity Isn't A Religion`,
              sermonSubTitle: ``,
              sermonDate: `September 23, 2025`,
              sermonChannel: `John 14:6`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=LE-EeZDJOuk`
            }
          ]
        },
        { firstName: `Mark`,
          lastName: `Levin`,
          thumb: AllThumbs.Levin,
          itemLinks: [
            { sermonTitle: `The Battle Against Marxism and Soft Tyranny`,
              sermonSubTitle: `Defending America ft. Milton Friedman`,
              sermonDate: `July 15, 2025`,
              sermonChannel: `The Mark Levin Show`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=QEBqOsX3IZc`
            },
            { sermonTitle: `Why Unelected Judges Are A HUGE Threat To Liberty`,
              sermonSubTitle: `Bureaucratic BS`,
              sermonDate: `August 27, 2025`,
              sermonChannel: `LevinTV`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=l2GN4UH7HT4`
            },
            { sermonTitle: `Mark Levin Explains Madison’s Defense of Property Rights`,
              sermonSubTitle: `The Founders VS Socialism`,
              sermonDate: `August 28, 2025`,
              sermonChannel: `LevinTV`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=8M9SUUXzUzQ`
            },
            { sermonTitle: `The REAL Reason why Communism Will NEVER Work`,
              sermonSubTitle: `Mark Levin`,
              sermonDate: `September 2, 2025`,
              sermonChannel: `BlazeTV`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=0ABkduwn4dQ`
            },
            { sermonTitle: `Levin unravels Democrats’ ‘propaganda’`,
              sermonSubTitle: `Life, Liberty & Levin`,
              sermonDate: `July 28, 2025`,
              sermonChannel: `Fox News`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=pO41M-QVlZw`
            },
            { sermonTitle: `Jimmy Kimmel is only a victim of his own 'narcissism'`,
              sermonSubTitle: `Life, Liberty & Levin - Violence & Free Speech`,
              sermonDate: `September 27, 2025`,
              sermonChannel: `Fox News`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=BHPuANkYlG4`
            }
          ]
        },
        { firstName: `Rush`,
          lastName: `Limbaugh`,
          thumb: AllThumbs.Limbaugh,
          itemLinks: [
            { sermonTitle: `Rush Limbaugh at CPAC 2009`,
              sermonSubTitle: `The Speech That Inspired a Movement`,
              sermonDate: ``,
              sermonChannel: `CPAC`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=w32hFilBAUg`
            }
          ]
        },
        { firstName: `Max`,
          lastName: `Lucado`,
          thumb: AllThumbs.LucadoM,
          itemLinks: [
            { sermonTitle: `Max Lucado on Overcoming Grief in Dark Times`,
              sermonSubTitle: `The Glenn Beck Podcast | Ep 266`,
              sermonDate: `September 13, 2025`,
              sermonChannel: `Glenn Beck`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=1uhdYMdB3Fs`
            }
          ]
        },
        { firstName: `Eric`,
          lastName: `Metaxas`,
          thumb: AllThumbs.Metaxas,
          itemLinks: [
            { sermonTitle: `Bonhoeffer: Pastor, Spy, Assassin`,
              sermonSubTitle: ``,
              sermonDate: `November 22, 2024`,
              sermonChannel: `Socrates in the City`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=ZoJZKC17KuI`
            }
          ]
        },
        { firstName: `Stephen`,
          lastName: `Meyer`,
          thumb: AllThumbs.Meyer,
          itemLinks: [
            { sermonTitle: `The Universe Had a Beginning`,
              sermonSubTitle: `Why That Shook Einstein`,
              sermonDate: ``,
              sermonChannel: `Stephen Meyer`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=xl0HRrElzGw`
            },
            { sermonTitle: `Science Is Pointing Back to God...Here’s Why`,
              sermonSubTitle: `How The Big Bang Points To God`,
              sermonDate: `August 6, 2025`,
              sermonChannel: `Stephen Meyer`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=J3j0j0hGlyk`
            },
            { sermonTitle: `The Real Reason Our Culture Is Falling Apart`,
              sermonSubTitle: `40 Years Ago, We Were Warned`,
              sermonDate: `August 1, 2025`,
              sermonChannel: `Stephen Meyer`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=al8F1aTY2uY`
            }
          ]
        },
        { firstName: `Fr. Mike`,
          lastName: `O'Connor`,
          thumb: AllThumbs.OConnor,
          itemLinks: [
            { sermonTitle: `Come Holy Spirit`,
              sermonSubTitle: `Pod Apostle`,
              sermonDate: `May 28, 2023`,
              sermonChannel: `Our Lady of the Gulf Catholic Church`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=QJr4KB6N8xI`
            },
            { sermonTitle: `Lord Save Me!`,
              sermonSubTitle: `Pod Apostle`,
              sermonDate: `August 13, 2023`,
              sermonChannel: `Our Lady of the Gulf Catholic Church`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=pWXIoidqzcA`
            },
            { sermonTitle: `The Cross, Bishop Sheen, Personal Responsibility and Charlie Kirk`,
              sermonSubTitle: `Pod Apostle`,
              sermonDate: `September 14, 2025`,
              sermonChannel: `Our Lady of the Gulf Catholic Church`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=e5qb6dQVyTk`
            },
            { sermonTitle: `Trans Insanity - Gender Dysphoria, Grooming and Mutilation`,
              sermonSubTitle: `Pod Apostle`,
              sermonDate: `April 1, 2023`,
              sermonChannel: `Our Lady of the Gulf Catholic Church`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=Ns7qzBxQDgc`
            },
            { sermonTitle: `Why Do People Quit Believing?`,
              sermonSubTitle: `Pod Apostle`,
              sermonDate: ` November 17, 2023`,
              sermonChannel: `Our Lady of the Gulf Catholic Church`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=b9JMwVHahf8`
            },
            { sermonTitle: `Strive To Keep The Commandments Of God`,
              sermonSubTitle: `Pod Apostle`,
              sermonDate: `May 19, 2025`,
              sermonChannel: `Our Lady of the Gulf Catholic Church`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=8yYDXtPovkk`
            },
            { sermonTitle: `Life’s instructions are available`,
              sermonSubTitle: `Pod Apostle`,
              sermonDate: `August 8, 2025`,
              sermonChannel: `Our Lady of the Gulf Catholic Church`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=-FTph7rVKNI`
            },
            { sermonTitle: `The Greatest Sermon!`,
              sermonSubTitle: `Pod Apostle`,
              sermonDate: `January 29, 2023`,
              sermonChannel: `Our Lady of the Gulf Catholic Church`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=rUwEt3HFXLE`
            },
            { sermonTitle: `I Will Not Leave You Orphaned.`,
              sermonSubTitle: `Pod Apostle`,
              sermonDate: `May 14, 2023`,
              sermonChannel: `Our Lady of the Gulf Catholic Church`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=0T9EGIW5qZs`
            },
            { sermonTitle: `The Cross Is Proof Of God's Love`,
              sermonSubTitle: `Pod Apostle`,
              sermonDate: `June 19, 2023`,
              sermonChannel: `Our Lady of the Gulf Catholic Church`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=siqqeDpKWcg`
            },
            { sermonTitle: `We Are All A Work In Progress`,
              sermonSubTitle: `Pod Apostle`,
              sermonDate: `August 9, 2025`,
              sermonChannel: `Our Lady of the Gulf Catholic Church`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=moCiuut_Gi8`
            },
            { sermonTitle: `Your Path To Self Knowledge Comes From — Serious Reflection —`,
              sermonSubTitle: `Pod Apostle`,
              sermonDate: `August 26, 2025`,
              sermonChannel: `Our Lady of the Gulf Catholic Church`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=0GypCNd76JA`
            },
            { sermonTitle: `Political pundits “working” for the culture of death…`,
              sermonSubTitle: `Pod Apostle`,
              sermonDate: `August 31, 2025`,
              sermonChannel: `Our Lady of the Gulf Catholic Church`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=CxupZT7Rc8s`
            },
            { sermonTitle: `Encourage One Another and Build One Another Up`,
              sermonSubTitle: `Pod Apostle`,
              sermonDate: `September 2, 2025`,
              sermonChannel: `Our Lady of the Gulf Catholic Church`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=HOsBgDLky2M`
            },
            { sermonTitle: `— God Gives Us Grace To Be Holy —`,
              sermonSubTitle: `Pod Apostle`,
              sermonDate: `September 24, 2025`,
              sermonChannel: `Our Lady of the Gulf Catholic Church`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=W9AvMFslSk8`
            },
            { sermonTitle: `From Hypocrisy to Cowardice... Lord Increase Our Faith.`,
              sermonSubTitle: `Pod Apostle`,
              sermonDate: `October 5, 2025`,
              sermonChannel: `Our Lady of the Gulf Catholic Church`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=14Kqi1HVvGE`
            },
            { sermonTitle: `— Be An Agent Of Mercy —`,
              sermonSubTitle: `Pod Apostle`,
              sermonDate: `October 6, 2025`,
              sermonChannel: `Our Lady of the Gulf Catholic Church`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=elcJhfSKBWQ`
            },
            { sermonTitle: `— Return To Christ, Today —`,
              sermonSubTitle: `Pod Apostle`,
              sermonDate: `October 7, 2025`,
              sermonChannel: `Our Lady of the Gulf Catholic Church`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=JJQBLmCkaSI`
            },
            { sermonTitle: `— God Our Father Loves Us Like His Children —`,
              sermonSubTitle: `Pod Apostle`,
              sermonDate: `October 8, 2025`,
              sermonChannel: `Our Lady of the Gulf Catholic Church`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=ikXSFmIQLhM`
            }
          ]
        },
        { firstName: `David`,
          lastName: `Pawson`,
          thumb: AllThumbs.Pawson,
          itemLinks: [
            { sermonTitle: `Believers In Hell`,
              sermonSubTitle: ``,
              sermonDate: `April 2016`,
              sermonChannel: `David Pawson - Official`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=8gh2LXHUhIA`
            }
          ]
        },
        { firstName: `Jordan B`,
          lastName: `Peterson`,
          thumb: AllThumbs.Peterson,
          itemLinks: [
            { sermonTitle: `The Devil and Karl Marx`,
              sermonSubTitle: `Dr. Paul Kengor | EP 455`,
              sermonDate: ``,
              sermonChannel: `Jordan B Peterson`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=LOFIHp6aTuE`
            },
            { sermonTitle: `Nietzsche Predicted This, He Was Right`,
              sermonSubTitle: `The Future`,
              sermonDate: `Aug 5, 2025`,
              sermonChannel: `Jordan B Peterson Clips`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=Jd4cpHfThZs`
            },
            { sermonTitle: `Every New Religion Is Haunted by the Same Devil`,
              sermonSubTitle: `From Ep. 371 - Eric Metaxas`,
              sermonDate: `Aug 15, 2025`,
              sermonChannel: `Jordan B Peterson Clips`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=Q9Xp6-dTOn8`
            },
            { sermonTitle: `Charlie Kirk’s Personal Story | EP 542`,
              sermonSubTitle: `The Education System is Hyper Feminine`,
              sermonDate: `April 28, 2025`,
              sermonChannel: `Jordan B Peterson`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=dP0TagcNvCg`
            }
          ]
        },
        { firstName: `Dennis`,
          lastName: `Prager`,
          thumb: AllThumbs.Prager,
          itemLinks: [
            { sermonTitle: `Video Marathon: The Ten Commandments`,
              sermonSubTitle: ``,
              sermonDate: ``,
              sermonChannel: `PragerU`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=Ih-AJB6D8WI`
            },
            { sermonTitle: `Dennis Prager: Israel's Place in the World`,
              sermonSubTitle: ``,
              sermonDate: `April 12, 2024`,
              sermonChannel: `Socrates In The City`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=ktezN_kH49k`
            }
          ]
        },
        { firstName: `Ronald`,
          lastName: `Reagan`,
          thumb: AllThumbs.Reagan,
          itemLinks: [
            { sermonTitle: `"A Time for Choosing" by Ronald Reagan`,
              sermonSubTitle: ``,
              sermonDate: `October 27, 1964`,
              sermonChannel: `Ronald Reagan Presidential Foundation & Institute`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=qXBswFfh6AY`
            },
            { sermonTitle: `1st Inaugural Address: President Reagans Inaugural Address`,
              sermonSubTitle: ``,
              sermonDate: `January 20, 1981`,
              sermonChannel: `Ronald Reagan Presidential Foundation & Institute`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=LToM9bAnsyM`
            },
            { sermonTitle: `Ronald Reagan God and America`,
              sermonSubTitle: ``,
              sermonDate: ``,
              sermonChannel: `Fred Windham`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=u5yDoaXsIZ4`
            },
            { sermonTitle: `President Reagan's Remarks at the Annual National Prayer Breakfast`,
              sermonSubTitle: ``,
              sermonDate: `February 2, 1984`,
              sermonChannel: `Ronald Reagan Presidential Foundation & Institute`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=v48JPdAjGdY`
            }
          ]
        },
        { firstName: `Fr. John`,
          lastName: `Riccardo`,
          thumb: AllThumbs.RiccardoJ,
          itemLinks: [
            { sermonTitle: `The Beauty of Hope`,
              sermonSubTitle: `Don't Despair`,
              sermonDate: `March 7, 2023`,
              sermonChannel: `Word on Fire Institute`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=ly2h_ipcOek`
            }
          ]
        },
        { firstName: `Francis`,
          lastName: `Schaeffer`,
          thumb: AllThumbs.Schaeffer,
          itemLinks: [
            { sermonTitle: `A Christian Manifesto`,
              sermonSubTitle: `Dr. Francis Schaeffer Lecture Video`,
              sermonDate: `1982`,
              sermonChannel: `Christian Sermons and Audio Books`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=VwLDP8pocwo`
            },
            { sermonTitle: `The Watershed of the Evangelical World`,
              sermonSubTitle: ``,
              sermonDate: ``,
              sermonChannel: `Apologia Acts 17:17`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=cXvzvivdVlA`
            },
            { sermonTitle: `DR SCHAEFFER'S FINAL ADDRESS AND Q&A`,
              sermonSubTitle: ``,
              sermonDate: `1984`,
              sermonChannel: `FrancisSchaefferStudies.org`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=Heu_F1iAdEU`
            }
          ]
        },
        { firstName: `Rabbi`,
          lastName: `Schneider`,
          thumb: AllThumbs.Schneider,
          itemLinks: [
            { sermonTitle: `A Cure to Anxiety`,
              sermonSubTitle: `Isaiah 41: Friends, Servants, and Victors in God`,
              sermonDate: `Apr 17, 2023`,
              sermonChannel: `Discovering the Jewish Jesus with Rabbi Schneider`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=17jxRb-nHA8`
            },
            { sermonTitle: `The Lost Roots Of Christianity`,
              sermonSubTitle: `Decoding the Torah Season 1`,
              sermonDate: `Apr 28, 2025`,
              sermonChannel: `Discovering the Jewish Jesus with Rabbi Schneider`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=ZvLVzGwhNy8`
            },
            { sermonTitle: `When God’s Instructions Don’t Make Sense`,
              sermonSubTitle: `Stories From the Sea of Galilee`,
              sermonDate: `July 21, 2025`,
              sermonChannel: `Discovering the Jewish Jesus with Rabbi Schneider`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=-rOjSobjjDM`
            },
            { sermonTitle: `Start by Stopping`,
              sermonSubTitle: `Decoding the Torah Season 2`,
              sermonDate: `July 2, 2025`,
              sermonChannel: `Discovering the Jewish Jesus with Rabbi Schneider`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=FD9ltgUysvs`
            },
            { sermonTitle: `The Threat of Surface-Level Sanctification`,
              sermonSubTitle: `Decoding the Torah Season 2`,
              sermonDate: `June 23, 2025`,
              sermonChannel: `Discovering the Jewish Jesus with Rabbi Schneider`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=ZZbtmDSJzFM`
            },
            { sermonTitle: `The Themes of Redemption - Rosh Hashanah, Yom Kippur, and Sukkot`,
              sermonSubTitle: `Sukkot: Trusting God To Provide`,
              sermonDate: ``,
              sermonChannel: `Discovering the Jewish Jesus with Rabbi Schneider`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=63edl05RJ_k`
            },
            { sermonTitle: `Why the Mosaic Law Is Still Relevant`,
              sermonSubTitle: `The Sermon on the Mount Season 1`,
              sermonDate: `September 1, 2025`,
              sermonChannel: `Discovering the Jewish Jesus with Rabbi Schneider`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=7-byz5kTwPQ`
            }
          ]
        },
        { firstName: `Thomas`,
          lastName: `Sowell`,
          thumb: AllThumbs.Sowell,
          itemLinks: [
            { sermonTitle: `Thomas Sowell on the Myths of Economic Inequality`,
              sermonSubTitle: `Uncommon Knowledge with Peter Robinson`,
              sermonDate: ``,
              sermonChannel: `Hoover Institution`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=mS5WYp5xmvI`
            }
          ]
        },
        { firstName: `Charles H`,
          lastName: `Spurgeon`,
          thumb: AllThumbs.Spurgeon,
          itemLinks: [
            { sermonTitle: `Healed or Deluded- Which?`,
              sermonSubTitle: `(Jeremiah 8:11 & Jeremiah 17:14) - Charles Spurgeon Sermon`,
              sermonDate: `May 7, 1882`,
              sermonChannel: `Spurgeon Sermon Series`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=C1mh2-212Mc`
            },
            { sermonTitle: `The Believer Sinking in the Mire`,
              sermonSubTitle: `(Psalm 69:14) - Charles Spurgeon Sermon`,
              sermonDate: `approx 1865`,
              sermonChannel: `Spurgeon Sermon Series`,  
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=wAUkV66cmjw`
            },
            { sermonTitle: `Remember Lot's Wife`,
              sermonSubTitle: `(Luke 17:32) - Charles Spurgeon Sermon`,
              sermonDate: `August 24, 1879`,
              sermonChannel: `Spurgeon Sermon Series`,  
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=9qPakOq9TDo`
            },
            { sermonTitle: `Dilemma and Deliverance (Psalm 9:10)`,
              sermonSubTitle: `God Never Foresakes Us`,
              sermonDate: `December 4, 1859`,
              sermonChannel: `Spurgeon Sermon Series`,  
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=NxGEdAUin8o`
            },
            { sermonTitle: `"Is It True?"`,
              sermonSubTitle: `(Daniel 3:14) Standing Firm - Charles Spurgeon Sermon`,
              sermonDate: `September 12, 1886`,
              sermonChannel: `Spurgeon Sermon Series`,  
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=vC2TZvcDJw4`
            },
            { sermonTitle: `The Desire of the Soul in Spiritual Darkness`,
              sermonSubTitle: `(Isaiah 26:9) - Charles Spurgeon Sermon`,
              sermonDate: `June 24, 1855`,
              sermonChannel: `Spurgeon Sermon Series`,  
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=nWbl3ShIeF0`
            },
            { sermonTitle: `How Saints May Help the Devil`,
              sermonSubTitle: `(Ezekiel 16:54) When Satan Uses Saints`,
              sermonDate: `July 24, 1859`,
              sermonChannel: `Spurgeon Sermon Series`,  
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=RUJYisdrZ0M`
            },
            { sermonTitle: `Brave Waiting (Psalm 27:14)`,
              sermonSubTitle: `Wait On The Lord`,
              sermonDate: `August 26, 1877`,
              sermonChannel: `Spurgeon Sermon Series`,  
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=0SdOh-08nEA`
            },
            { sermonTitle: `Away With Fear (Isaiah 41:10)`,
              sermonSubTitle: `No More Fear`,
              sermonDate: `April 10, 1870`,
              sermonChannel: `Spurgeon Sermon Series`,  
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=vkC9PCfX_us`
            },
            { sermonTitle: `Good Advice For Troublous Times (Isaiah 26:20)`,
              sermonSubTitle: `Good Advice`,
              sermonDate: `September 9, 1888`,
              sermonChannel: `Spurgeon Sermon Series`,  
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=hTYDWtFeMeQ`
            },
            { sermonTitle: `Seekers Directed and Encouraged (Jeremiah 29:13)`,
              sermonSubTitle: `Seeking God`,
              sermonDate: ``,
              sermonChannel: `Spurgeon Sermon Series`,  
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=vX0MSoxa-Zk`
            },
            { sermonTitle: `The Dual Nature and the Duel Within`,
              sermonSubTitle: `(Romans 7:23) The Duel Within`,
              sermonDate: `Around 1879`,
              sermonChannel: `Spurgeon Sermon Series`,  
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=nl794IKUERc`
            },
            { sermonTitle: `The Sitting of the Refiner (Malachi 3:3)`,
              sermonSubTitle: `God Our Refiner`,
              sermonDate: `Around 1881`,
              sermonChannel: `Spurgeon Sermon Series`,  
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=rVhh1BImA8I`
            },
            { sermonTitle: `Think Well and Do Well (Psalm 26:3)`,
              sermonSubTitle: `Train Your Thoughts`,
              sermonDate: `October 23, 1870`,
              sermonChannel: `Spurgeon Sermon Series`,  
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=Mm8srJyFgLA`
            },
            { sermonTitle: `All These Things (Genesis 42:36, Isaiah 38:16 & Romans 8:37 )`,
              sermonSubTitle: `A New Perspective`,
              sermonDate: `October 18, 1868`,
              sermonChannel: `Spurgeon Sermon Series`,  
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=-5rec59hAe0`
            },
            { sermonTitle: `A Cure for Care (1 Peter 5:6,7)`,
              sermonSubTitle: `A Cure For Worry`,
              sermonDate: `January 12, 1862`,
              sermonChannel: `Spurgeon Sermon Series`,  
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=gXbcqnxQi4o`
            },
            { sermonTitle: `The Singing Army (2 Chronicles 20:4)`,
              sermonSubTitle: `Praise When Weakest`,
              sermonDate: `November 23, 1876`,
              sermonChannel: `Spurgeon Sermon Series`,  
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=oq8HbnVUqZc`
            },
            { sermonTitle: `Why Some Seekers Are Not Saved (Isaiah 59:1-2)`,
              sermonSubTitle: `What Holds You Back?`,
              sermonDate: `May 8, 1887`,
              sermonChannel: `Spurgeon Sermon Series`,  
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=slh_CpjaVZI`
            },
            { sermonTitle: `False Professors Solemnly Warned (Philippians 3:18,19)`,
              sermonSubTitle: `False Believers`,
              sermonDate: `August 24, 1856`,
              sermonChannel: `Spurgeon Sermon Series`,  
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=9HwqVpcbw-4`
            },
            { sermonTitle: `Desires Towards God: A Sermon for the Weak (Psalm 38:9)`,
              sermonSubTitle: `Desiring God`,
              sermonDate: `October 24, 1880`,
              sermonChannel: `Spurgeon Sermon Series`,  
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=uxtdhbckutg`
            },
            { sermonTitle: `Lecture: The need for Decision for the Truth`,
              sermonSubTitle: `The Truth Matters`,
              sermonDate: `1874`,
              sermonChannel: `Spurgeon Sermon Series`,  
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=OYWw76ZxrZ4`
            },
            { sermonTitle: `Spiritual Convalescence (Zechariah 10:12)`,
              sermonSubTitle: `Spiritually Recharged`,
              sermonDate: `March 17, 1864`,
              sermonChannel: `Spurgeon Sermon Series`,  
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=HUTcv3gCeE4`
            }
          ]
        },
        { firstName: `Corrie`,
          lastName: `Ten Boom`,
          thumb: AllThumbs.TenBoom,
          itemLinks: [
            { sermonTitle: `The Hiding Place - Full Movie`,
              sermonSubTitle: `A Billy Graham Film`,
              sermonDate: ``,
              sermonChannel: `Billy Graham Evangelistic Association`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=-zNDe30_eKw`
            },
            { sermonTitle: `Corrie Ten Boom Interviewed by Kathryn Kuhlman`,
              sermonSubTitle: ``,
              sermonDate: ``,
              sermonChannel: `BRMinistries`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=_41_Tk5mEuE`
            }
          ]
        },
        { firstName: `David`,
          lastName: `Wilkerson`,
          thumb: AllThumbs.WilkersonD,
          itemLinks: [
            { sermonTitle: `Impatient`,
              sermonSubTitle: `I Almost Gave Up`,
              sermonDate: `June 21, 1996`,
              sermonChannel: `World Challenge`,
              sermonDescript: `In this sermon preached June 21, 1996, David Wilkerson encourages us to have patience and wait on the Lord.`,
              sermonLink: `https://www.youtube.com/watch?v=aRha9OTrmuk`
            },
            { sermonTitle: `Don’t Waste Your Afflictions`,
              sermonSubTitle: `Why Did God Allow This?`,
              sermonDate: `August 25, 1996`,
              sermonChannel: `World Challenge`,  
              sermonDescript: `Preached on August 25th 1996, Pastor David Wilkerson delivers a profound sermon on the spiritual purpose of affliction.`,
              sermonLink: `https://www.youtube.com/watch?v=6UiQ9bRgt2s`
            },
            { sermonTitle: `Taking Back Control of Your Life`,
              sermonSubTitle: ``,
              sermonDate: ``,
              sermonChannel: `World Challenge`,  
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=27mJqMdeqTM`
            },
            { sermonTitle: `It Is Time to Trust the Lord`,
              sermonSubTitle: `Lay Down Your Fear`,
              sermonDate: ``,
              sermonChannel: `World Challenge`,  
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=ehVCTLWzpAw`
            },
            { sermonTitle: `Out of the Depths I Cried`,
              sermonSubTitle: `God Sees Your Struggle`,
              sermonDate: ``,
              sermonChannel: `World Challenge`,  
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=4g7adZpFOHE`
            },
            { sermonTitle: `The Ever-Increasing Demands of Faith`,
              sermonSubTitle: `Is God Testing You?`,
              sermonDate: ``,
              sermonChannel: `World Challenge`,  
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=siauldlf0z8`
            },
            { sermonTitle: `An Eclipse of Faith`,
              sermonSubTitle: `Has Your Faith Been Shattered?`,
              sermonDate: ``,
              sermonChannel: `World Challenge`,  
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=w1Orv_-h77k`
            },
            { sermonTitle: `What Every Christian Should Know About Spiritual Growth`,
              sermonSubTitle: `Struggle Means Growth`,
              sermonDate: ``,
              sermonChannel: `World Challenge`,  
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=VvzxU2hOe0E`
            },
            { sermonTitle: `Why God Allows Troubles in a Christian Life`,
              sermonSubTitle: ``,
              sermonDate: `December 20, 1996`,
              sermonChannel: `World Challenge`,  
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=JFFEu_ZOP08`
            },
            { sermonTitle: `Are You a Contented Christian?`,
              sermonSubTitle: `Joy In The Wilderness`,
              sermonDate: ``,
              sermonChannel: `World Challenge`,  
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=jm13cZiYWp4`
            },
            { sermonTitle: `Have You Felt Like Giving up Lately?`,
              sermonSubTitle: `Call Out To God`,
              sermonDate: ``,
              sermonChannel: `World Challenge`,  
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=sfrsxELj4Z0`
            },
            { sermonTitle: `God's People Will Never Be Ashamed in the Time of Calamity`,
              sermonSubTitle: `Expect The Impossible`,
              sermonDate: ``,
              sermonChannel: `World Challenge`,  
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=vwDHEdwnQdE`
            },
            { sermonTitle: `The Nearness of God`,
              sermonSubTitle: `God Will Deliver You`,
              sermonDate: `December 4, 1994`,
              sermonChannel: `World Challenge`,  
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=O5CCEV7RcJI`
            },
            { sermonTitle: `Disappointments Can Be Dangerous`,
              sermonSubTitle: `Feeling Let Down By God?`,
              sermonDate: ``,
              sermonChannel: `World Challenge`,  
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=eBag__W_zvs`
            },
            { sermonTitle: `Time to Weep for America`,
              sermonSubTitle: `America's Deadly Party`,
              sermonDate: `(2009 - 2011)`,
              sermonChannel: `World Challenge`,  
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=58L9hc3IOf0`
            },
            { sermonTitle: `Looking for the Right Church in the Wrong Places`,
              sermonSubTitle: `Can't Find A True Chruch?`,
              sermonDate: `October 5, 2025`,
              sermonChannel: `World Challenge`,  
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=hawZ3wZ4uZo`
            },
            { sermonTitle: `Learning How to Encourage Yourself in the Lord`,
              sermonSubTitle: `Psalm 16`,
              sermonDate: ``,
              sermonChannel: `World Challenge`,  
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=6ze6zsedJY4`
            }
          ]
        },
        { firstName: `Gary`,
          lastName: `Wilkerson`,
          thumb: AllThumbs.WilkersonG,
          itemLinks: [
            { sermonTitle: `Getting Healed`,
              sermonSubTitle: `Gary Wilkerson`,
              sermonDate: `September 8, 2024`,
              sermonChannel: `World Challenge`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=Bvu8WoOrUYM`
            }
          ]
        },
        { firstName: `Ravi`,
          lastName: `Zacharias`,
          thumb: AllThumbs.Zacharias,
          itemLinks: [
            { sermonTitle: `Ravi Zacharias Speaks To 40,000`,
              sermonSubTitle: ``,
              sermonDate: `September 25, 2017`,
              sermonChannel: `BRMinistries`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=a5_6MB8vHYY`
            },
            { sermonTitle: `Ravi Zacharias`,
              sermonSubTitle: `The Ben Shapiro Show Sunday Special Ep. 60`,
              sermonDate: `July 21, 2019`,
              sermonChannel: `DailyWire+`,
              sermonDescript: ``,
              sermonLink: `https://www.youtube.com/watch?v=RIMwWtt_EVQ`
            }
          ]
        }
    ]
};

export default SermonLinksList;